// Mapa de la ruta al lado de la lista (Ruta y Armar ruta en pantallas anchas). Leaflet se descarga recién acá, en un
// archivo aparte: en el celular no se pide nunca y la primera carga no crece.
import { lazy, Suspense } from 'react';
import type { Ruta } from '../datos/tipos';
import { EsqueletoMapa } from './Esqueletos';

const MapaRuta = lazy(() => import('./MapaRuta'));

export function PanelMapa({ ruta }: { ruta: Ruta }) {
  return (
    <section
      aria-label="Mapa de la ruta"
      className="relative h-full overflow-hidden rounded-3xl border border-stone-200 bg-stone-100 dark:border-stone-800 dark:bg-stone-900"
    >
      <Suspense fallback={<EsqueletoMapa />}>
        <MapaRuta ruta={ruta} />
      </Suspense>
      <span className="pointer-events-none absolute top-3 left-3 z-10 rounded-full bg-white/90 px-3 py-1 text-xs text-stone-700 shadow dark:bg-stone-800/90 dark:text-stone-200">
        Líneas rectas, no calles
      </span>
    </section>
  );
}
